import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from 'cl-common-angular';
import { map, shareReplay, tap } from 'rxjs/operators';
import { IAuth } from './auth';

@Injectable({ providedIn: 'root' })
export class AuthService implements AuthenticationService {

    private readonly routePrefix: string = '/api/auth/';

    private auth$ = this.httpClient.get<IAuth>(this.routePrefix).pipe(
        map(authInfo => ({ ...authInfo, firstName: authInfo.displayName.split(' ')[0] })),
        tap(authInfo => this.title.setTitle(authInfo.productName)),
        shareReplay(),
    );

    constructor(
        private httpClient: HttpClient,
        private title: Title,
    ) { }

    getAuthInfo = () => this.auth$;

}
